<template>
  <div class="gccc-container">
    <section class="common-section overview-section">
      <section-title :titleInfo="overviewTitle"></section-title>
      <div class="overview-layout">
        <div class="overview-copy">
          <p>
            光储充车棚将分布式光伏发电、储能调节与新能源汽车充电设施有机融合，在满足遮阳挡雨和停车需求的同时，为园区提供清洁、高效、便捷的补能服务。
          </p>
          <p>
            系统可结合场地条件灵活配置光伏容量、储能设备和充电终端，通过智能能源管理协调发、储、充各环节，提升绿电就地消纳能力和停车空间综合价值。
          </p>
          <div class="overview-tags">
            <div v-for="item in overviewTags" :key="item.title" class="overview-tag">
              <strong>{{ item.title }}</strong>
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
        <img
          class="overview-image"
          src="../images/gccc/gccc-overview.jpg"
          alt="光储充车棚整体解决方案"
        />
      </div>
    </section>

    <section class="common-section experience-section">
      <section-title :titleInfo="experienceTitle"></section-title>
      <div class="experience-layout">
        <div class="experience-cards">
          <article v-for="item in experiences" :key="item.title" class="experience-card">
            <div class="feature-icon">
              <operation-icon :name="item.icon"></operation-icon>
            </div>
            <div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.text }}</p>
            </div>
          </article>
        </div>
        <img
          class="storage-image"
          src="../images/gccc/gccc-storage.jpg"
          alt="光伏车棚与储能设备协同运行"
        />
      </div>
    </section>

    <section class="common-section scene-section">
      <section-title :titleInfo="sceneTitle"></section-title>
      <div class="scene-grid">
        <article v-for="item in scenes" :key="item.title" class="scene-card">
          <img :src="item.image" :alt="item.title" />
          <div class="scene-mask">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </article>
      </div>
    </section>

    <section class="common-section value-section">
      <section-title :titleInfo="valueTitle"></section-title>
      <div class="value-grid">
        <article v-for="item in values" :key="item.title" class="value-card">
          <div class="value-icon">
            <operation-icon :name="item.icon"></operation-icon>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.text }}</p>
        </article>
      </div>
    </section>

    <section class="contact-banner">
      <div>
        <h2>携手智融科技，共建绿色补能新空间</h2>
        <p>让每一次出行都更清洁、更舒适、更可持续</p>
      </div>
      <a href="tel:02583585700">
        <span>联系我们</span>
        <strong>025-83585700</strong>
      </a>
    </section>
  </div>
</template>

<script>
import SectionTitle from "../../components/section-title.vue";
import OperationIcon from "./operation-icon.vue";

export default {
  name: "CdyyGccc",
  components: { SectionTitle, OperationIcon },
  data() {
    return {
      overviewTitle: {
        bigtext1: "光储充车棚解决方案",
        smallText: "绿色供能 · 高效补能 · 场景融合",
      },
      experienceTitle: {
        bigtext1: "让补能空间成为园区新风景",
        smallText: "兼顾清洁能源利用、停车体验和园区空间品质",
      },
      sceneTitle: {
        bigtext1: "多场景适配，兼顾体验与价值",
        smallText: "因地制宜配置光伏、储能和充电设施，适配多元停车需求",
      },
      valueTitle: {
        bigtext1: "绿色补能空间价值",
        smallText: "从能源供给延伸至空间、体验与品牌形象的综合提升",
      },
      overviewTags: [
        { title: "光伏发电", text: "清洁能源就地利用" },
        { title: "储能调节", text: "削峰填谷灵活响应" },
        { title: "便捷充电", text: "即停即充高效补能" },
      ],
      experiences: [
        {
          title: "补能更自然",
          text: "清洁能源供给，低碳更安心。",
          icon: "green",
        },
        {
          title: "停车更舒适",
          text: "遮阳挡雨，环境舒适，出行更从容。",
          icon: "comfort",
        },
        {
          title: "空间更友好",
          text: "设施整洁有序，空间利用更高效。",
          icon: "space",
        },
        {
          title: "运营更轻松",
          text: "智能运维管理，日常运营省心省力。",
          icon: "data",
        },
        {
          title: "绿色形象升级",
          text: "科技与绿色融合，持续提升园区品质。",
          icon: "shield",
        },
      ],
      scenes: [
        {
          title: "园区办公",
          text: "绿色补能，员工出行更便捷",
          image: require("../images/gccc/scene-office.jpg"),
        },
        {
          title: "商业综合体",
          text: "客流友好，购物出行两无忧",
          image: require("../images/gccc/scene-commercial.jpg"),
        },
        {
          title: "社区停车场",
          text: "家门口补能，日常更安心",
          image: require("../images/gccc/scene-community.jpg"),
        },
        {
          title: "公共停车场",
          text: "便捷补能，服务更多车主",
          image: require("../images/gccc/scene-public.jpg"),
        },
        {
          title: "景区驿站",
          text: "旅途补能，畅游更安心",
          image: require("../images/gccc/scene-scenic.jpg"),
        },
        {
          title: "企业园区",
          text: "绿色赋能，助力低碳发展",
          image: require("../images/gccc/scene-enterprise.jpg"),
        },
      ],
      values: [
        { title: "绿色出行", text: "清洁供能，低碳未来", icon: "green" },
        { title: "灵活部署", text: "因地制宜，快速落地", icon: "aggregate" },
        { title: "协同供能", text: "光储协同，高效稳定", icon: "multi-grid" },
        { title: "舒适体验", text: "遮阳防雨，出行更舒适", icon: "comfort" },
        { title: "品牌焕新", text: "形象升级，价值提升", icon: "shield" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.gccc-container {
  width: 100%;
  color: #1d1d1d;
  background: #fff;
}

.common-section {
  box-sizing: border-box;
  padding: 100px clamp(32px, 8.33vw, 160px);
}

.overview-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(420px, 0.9fr);
  gap: 72px;
  align-items: center;
}

.overview-copy {
  p {
    margin: 0 0 18px;
    color: #4e5868;
    font-size: 18px;
    line-height: 2;
  }
}

.overview-tags {
  margin-top: 34px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #dfe7f2;
}

.overview-tag {
  padding: 24px 16px 4px 0;

  strong,
  span {
    display: block;
  }

  strong {
    margin-bottom: 8px;
    color: #1f63ea;
    font-size: 22px;
    font-weight: 500;
  }

  span {
    color: #7d8797;
    font-size: 14px;
  }
}

.overview-image {
  width: 100%;
  height: 430px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 18px 44px rgba(24, 57, 108, 0.14);
}

.experience-section,
.value-section {
  background: #f6f8fc;
}

.experience-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(430px, 0.9fr);
  gap: 28px;
  align-items: stretch;
}

.experience-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.experience-card {
  min-height: 150px;
  box-sizing: border-box;
  padding: 26px 24px;
  display: flex;
  gap: 18px;
  border: 1px solid #e2e9f3;
  background: #fff;

  &:last-child {
    grid-column: 1 / -1;
  }

  h3 {
    margin: 3px 0 12px;
    font-size: 21px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: #7d8797;
    font-size: 15px;
    line-height: 1.8;
  }
}

.feature-icon,
.value-icon {
  width: 52px;
  height: 52px;
  flex: none;
  box-sizing: border-box;
  padding: 10px;
  color: #1f63ea;
  border: 1px solid #cfe0ff;
  background: #f1f6ff;
}

.storage-image {
  width: 100%;
  height: 100%;
  min-height: 468px;
  object-fit: cover;
}

.scene-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.scene-card {
  height: 270px;
  position: relative;
  overflow: hidden;
  background: #dfe6ef;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.5s;
  }

  &:hover img {
    transform: scale(1.035);
  }
}

.scene-mask {
  box-sizing: border-box;
  padding: 48px 24px 22px;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  color: #fff;
  background: linear-gradient(transparent, rgba(4, 29, 65, 0.88));

  h3 {
    margin: 0 0 8px;
    font-size: 22px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 14px;
  }
}

.value-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.value-card {
  min-height: 190px;
  box-sizing: border-box;
  padding: 30px 24px;
  border: 1px solid #e2e9f3;
  background: #fff;

  .value-icon {
    margin-bottom: 22px;
  }

  h3 {
    margin: 0 0 10px;
    color: #1f63ea;
    font-size: 20px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: #7d8797;
    font-size: 14px;
    line-height: 1.7;
  }
}

.contact-banner {
  min-height: 190px;
  box-sizing: border-box;
  padding: 42px clamp(32px, 8.33vw, 160px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  background:
    linear-gradient(90deg, rgba(11, 68, 180, 0.98), rgba(38, 111, 239, 0.9)),
    url("../images/gccc/scene-enterprise.jpg") center 54% / cover;

  h2 {
    margin: 0 0 12px;
    font-size: 30px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.75);
    font-size: 16px;
  }

  a {
    min-width: 220px;
    box-sizing: border-box;
    padding: 18px 28px;
    color: #1f63ea;
    text-decoration: none;
    background: #fff;

    span,
    strong {
      display: block;
    }

    span {
      margin-bottom: 6px;
      color: #7d8797;
      font-size: 13px;
    }

    strong {
      font-size: 21px;
      font-weight: 500;
    }
  }
}

@media (max-width: 1200px) {
  .overview-layout,
  .experience-layout {
    gap: 38px;
  }

  .value-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .common-section {
    padding: 70px 28px;
  }

  .overview-layout,
  .experience-layout {
    grid-template-columns: 1fr;
  }

  .overview-image {
    height: 360px;
  }

  .storage-image {
    min-height: 360px;
  }

  .scene-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .contact-banner {
    gap: 30px;
  }
}

@media (max-width: 640px) {
  .overview-tags,
  .experience-cards,
  .scene-grid,
  .value-grid {
    grid-template-columns: 1fr;
  }

  .experience-card:last-child {
    grid-column: auto;
  }

  .overview-image,
  .storage-image {
    height: 270px;
    min-height: 270px;
  }

  .contact-banner {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
